<div class="main">
  <div class="main-header">
    <p class="mat-headline-3">Atualizar dados de usuário</p>
  </div>
  <div class="main-content">
    <div>
      <p class="mat-headline-4">Identificação</p>
      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>CPF</mat-label>
        <input matInput [formControl]="userCpfFormControl" placeholder="CPF">
        @if (userCpfFormControl.hasError('required')) {
        <mat-error>Campo obrigatório</mat-error>
        }
        <mat-hint>CPF do usuário</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>Nome</mat-label>
        <input matInput [formControl]="nameFormControl" placeholder="Nome">
        @if (nameFormControl.hasError('required')) {
        <mat-error>Campo obrigatório</mat-error>
        }
        <mat-hint>Nome do usuário</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>Username</mat-label>
        <input matInput [formControl]="userNameFormControl" placeholder="Username">
        @if (userNameFormControl.hasError('required')) {
        <mat-error>Campo obrigatório</mat-error>
        }
        <mat-hint>Username do usuário</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>E-mail</mat-label>
        <input matInput [formControl]="userEmailFormControl" placeholder="E-mail">
        @if (userEmailFormControl.hasError('required')) {
        <mat-error>Campo obrigatório</mat-error>
        }
        <mat-hint>E-mail do usuário</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>Empresa</mat-label>
        <input matInput [formControl]="worksForCnpjFormControl" placeholder="CNPJ da empresa" readonly>
        @if (worksForCnpjFormControl.hasError('required')) {
        <mat-error>Campo obrigatório</mat-error>
        }
        <mat-hint>CNPJ da empresa que o usuário trabalha</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-identificacao">
        <mat-label>Tipo de usuário</mat-label>
        <mat-select [(value)]="selectedValue" [disabled]="isDisabled">
          @for (typeOfUser of options; track typeOfUser) {
          <mat-option [value]="typeOfUser.value">
            {{typeOfUser.viewValue}}
          </mat-option>
          }
        </mat-select>
        <mat-hint>Nível de acesso que o usuário terá</mat-hint>
      </mat-form-field>

    </div>
    <app-address-form [addressData]="addressData" [disabled]="isDisabled"></app-address-form>
  </div>
  <div class="main-footer">
    <button mat-flat-button id="newClientActionButton" class="footer-button" color="primary"
      (click)="updateUserActionButton()">Atualizar</button>
    <button mat-flat-button id="newClientActionButton" class="footer-cancel-button" color="primary"
      (click)="deleteProfile()">Deletar Perfil</button>
  </div>
</div>